import React, { useEffect, useState } from 'react';
import Layout from '../Layout';
import { Box, Container, Divider, Grid, Typography, Checkbox, makeStyles, Button } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { ApprovePMNgReviews, getPMNgReviews } from '../../ReduxStore/PreventiveMaintaince/CreatePMPlan';
import CustomBreadcrumbs from '../Breadcrumb';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { GridLoadingSpinner } from '@tmlconnected/avant-garde-components-library';

const useStyles = makeStyles((theme) => ({
    highlighted: {
        backgroundColor: theme.palette.action.hover,
    },
}));

const NGApprovecheckpoints = () => {
    const dispatch = useDispatch();
    const classes = useStyles();
    const breadcrumbsLinks = [
        { label: 'Home', href: '/' },
        { label: ' Preventive Maintenance', href: '/preventive-maintenance' }
    ];
    const [checkedState, setCheckedState] = useState([]);
    const [selectAll, setSelectAll] = useState(false);
    const [loading, setLoading] = useState(true);
    const [NgCheckpoints, setNgCheckpoint] = useState([]);
    const Role = localStorage.getItem("userRole");


    const handleCheckboxChange = (index) => {
        const updatedCheckedState = [...checkedState];
        updatedCheckedState[index] = !updatedCheckedState[index];
        setCheckedState(updatedCheckedState);

        const allChecked = updatedCheckedState.every(Boolean);
        setSelectAll(allChecked);
    };


    const handleSelectAllChange = (event) => {
        const checked = event.target.checked;
        setSelectAll(checked);

        const updatedCheckedState = NgCheckpoints.map(() => checked);
        setCheckedState(updatedCheckedState);
    };

    const handleSubmit = async () => {
        if (Role === 'admin' || Role === 'supplier') {
            const ngResolvePayload = NgCheckpoints
                .map((item, index) => {
                    if (checkedState[index]) {
                        return {
                            log_id: item.log_id,
                            approve: true  // Add approve field here
                        };
                    }
                    return null;
                })
                .filter(item => item !== null);

            const payload = {
                ng_approve: ngResolvePayload
            };
            try {
                const action = dispatch(ApprovePMNgReviews(payload));
                const res = await action.unwrap();
                console.log("response", res);
                if (res.StatusCode === 201) {
                    toast.success("Success");
                    getNgReview();
                } else {
                    toast.error("Something went wrong");
                }

            } catch (error) {
                toast.error(error.message || "Something went Wrong!");
            }
        } else {
            toast.info("You don't have access to do this activity!")
        }
    };


    const getNgReview = async () => {
        try {
            const action = dispatch(getPMNgReviews("?approval_pending=true"));
            const res = await action.unwrap();
            if (res.result) {
                setNgCheckpoint(res.result.ng_reviews);
            }

        } catch (error) {
            toast.error(error.message || "Something went Wrong!");
        }

    }


    useEffect(() => {
        const fetchData = async () => {
            await getNgReview();
            setLoading(false);
        };
        fetchData();
    }, [])


    if (loading) {
        return (
            <Layout>
                <Container>
                    <Box mt={4} display="flex" justifyContent="center" alignItems="center" minHeight="80vh" >
                        <GridLoadingSpinner />
                    </Box>
                </Container>
            </Layout>
        );
    }

    return (
        <Layout>
            <Container>
                {/* <Box mt={1}>
                    <Typography variant="h5" component="h1" gutterBottom>
                        Approve NG Checkpoints
                    </Typography>
                </Box> */}
                <Box mt={1} mb={2}>
                    <CustomBreadcrumbs links={breadcrumbsLinks} current="Approve NG Checkpoints" />
                </Box>
                <Box mb={2}>
                    {NgCheckpoints.length === 0 ?
                        (<Box display="flex" alignItems="center" justifyContent="center" mt={4}>
                            <Typography variant="h5">No Approve NG Checkpoints</Typography>
                        </Box>) : (
                            <div className="checkpoint-box">
                                <Box className="table-container">
                                    <Grid container spacing={3} className="checkpoint-header" alignItems="center">
                                        <Grid item xs={1}>
                                            <Checkbox
                                                checked={selectAll}
                                                onChange={handleSelectAllChange}
                                            />
                                        </Grid>
                                        <Grid item xs={2}>
                                            <h3>Checkpoints</h3>
                                        </Grid>
                                        <Grid item xs={3}>
                                            <h3>Asset</h3>
                                        </Grid>
                                        <Grid item xs={2}>
                                            <h3>RFID NO</h3>
                                        </Grid>
                                        <Grid item xs={2}>
                                            <h3>Part No</h3>
                                        </Grid>
                                        <Grid item xs={2}>
                                            <h3>Review Comment</h3>
                                        </Grid>
                                    </Grid>
                                    <Divider />
                                    <Box className="table-content">
                                        {NgCheckpoints && NgCheckpoints.map((item, index) => {
                                            const assetDetails = item.assetMaster_details[item.asset_id];
                                            return (
                                                <React.Fragment key={index}>
                                                    <Grid
                                                        container
                                                        spacing={2}
                                                        alignItems="center"
                                                        className={`checkpoint-item ${checkedState[index] ? classes.highlighted : ''}`}
                                                    >
                                                        <Grid item xs={1}>
                                                            <Checkbox
                                                                checked={checkedState[index] || false}
                                                                onChange={() => handleCheckboxChange(index)}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={2}>
                                                            {item.check_point}
                                                        </Grid>
                                                        <Grid item xs={3}>
                                                            {assetDetails?.asset_text} ({(assetDetails.asset_no)?.slice(3)})
                                                        </Grid>
                                                        <Grid item xs={2}>
                                                            {item.rfidNo || "NA"}
                                                        </Grid>
                                                        <Grid item xs={2}>
                                                            {assetDetails?.material_no || "NA"}
                                                        </Grid>
                                                        <Grid item xs={2}>
                                                            {item.reviewed_comment || "NA"}
                                                        </Grid>
                                                    </Grid>
                                                </React.Fragment>
                                            );
                                        })}
                                    </Box>
                                </Box>
                                <Box mt={2}>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={handleSubmit}
                                    >
                                        Submit
                                    </Button>
                                </Box>
                            </div>
                        )}

                </Box>
            </Container>
            <ToastContainer />
        </Layout>
    );
};

export default NGApprovecheckpoints;
